import * as React from "react";

import { ManageWrapper } from "layouts/manageLayout";
import { EmptyListPlaceholder } from "components/emptyListPlaceholder";
import { getCompanies } from "../../redux/actions/companyActions";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { CompanyTable } from "../company/index";
import { Loader } from "../../components/loader/Loader";

export const Company: React.FC = () => {
  const dispatch = useAppDispatch();
  const { companies, isLoading } = useAppSelector((state) => state.company);

  const handleView = () => {
    if (companies.length !== 0) {
      return <CompanyTable companies={companies} />;
    }

    return <EmptyListPlaceholder />;
  };
  const handleLoader = () => {
    if (isLoading) {
      return <Loader />;
    }

    return null;
  };

  React.useEffect(() => {
    dispatch(getCompanies());
  }, [dispatch]);

  return (
    <ManageWrapper
      buttonText="Add a new company"
      manageText="a company"
      navigateTo="/company/new"
      isButtonVisible
    >
      {handleLoader()}
      {handleView()}
    </ManageWrapper>
  );
};
